module.exports = __webpack_public_path__ + "img/We've moved_en.c1d4b1c.png";